import React from 'react';
import { PktButton } from "@oslokommune/punkt-react";
import { PLASS_TILBUD_ROUTE } from '../../../routes';
import { goToUrl } from "../../../utils/utils";
import ApplicationCard from "../../ApplicationCard/ApplicationCard";

type TilbudCardProps = {
    barnNavn: string;
    applicationId: number
    svarFrist: string | null;
}

const TilbudCard = ({ barnNavn, applicationId, svarFrist }: TilbudCardProps) => {
    return (
        <ApplicationCard title={barnNavn} variant={"blå"}>
            <div className={"pkt-txt-16-light"}>
                Du har fått et tilbud om barnehageplass.
                Svarfrist er{' '}
                {svarFrist
                    ? new Date(svarFrist).toLocaleDateString('no', { dateStyle: 'long' })
                    : 'ikke satt'}.
            </div>
            <PktButton
                onClick={() => goToUrl(`${PLASS_TILBUD_ROUTE}/${applicationId}`)}
                size={"small"}
                className={"mt-size-16"}
            >
                Svar på tilbudet
            </PktButton>
        </ApplicationCard>
    );
};

export default TilbudCard;